import { Outlet, useLocation } from 'react-router-dom';
import { PremadeQuizzes } from './PremadeQuizzes-Homepage';
import { UserOwnedPremadeQuizzesProvider } from '@quizzach/contexts';

export const PremadeRoot = () => {
	const location = useLocation();
	const isRoot = location.pathname === '/premade';

	return (
		<UserOwnedPremadeQuizzesProvider>
			{isRoot && <PremadeQuizzes />}
			<Outlet />
		</UserOwnedPremadeQuizzesProvider>
	);
};
